import * as Sentry from "@sentry/react";

const deviceWrappers = [
  require("./wrappers/Esca2").default,
  require("./wrappers/Pearl2").default,
  require("./wrappers/Pearl21").default,
  require("./wrappers/Pearl3").default,
  require("./wrappers/Pearl2+").default,
  require("./wrappers/Fuse").default,
  require("./wrappers/Fuse11").default,
  require("./wrappers/Keon").default,
  require("./wrappers/PulseInteractive").default,
  require("./wrappers/Svakom").default,
  require("./wrappers/SvakomAlex").default,
  require("./wrappers/SvakomAlex2").default,
  require("./wrappers/SvakomHannes").default,
  require("./wrappers/SvakomSam").default,
  require("./wrappers/WeVibe").default,
  require("./wrappers/Cliona").default,
  require("./wrappers/PlayBulb").default,
  require("./wrappers/Cowgirl").default,
  require("./wrappers/Spot").default,
];

const RenamedDeviceWrapper = require("./wrappers/Spot").default;

/**
 * Get array of all possible device names
 */
export function getAllDeviceNames() {
  return deviceWrappers.reduce(
    (names, wrapper) => names.concat(wrapper.deviceNames),
    []
  );
}

// Some devices' names are not the names we want to display, so we use this mapping
const DEVICE_NAME_MAPPING = {
  "SWK-S63E": "Alex NEO 2",
  "SWK-S63E-A": "Alex NEO 2",
  "SWK-SE63": "Alex NEO 2",
  "SWK-SE63E": "Alex NEO 2",
  ALEXNEO2: "Alex NEO 2",
  "S63E Alex NEO 2": "Alex NEO 2",
  "SWK-SX013A": "Pulse Lite NEO",
  "Phoenix Neo 2": "Phoenix NEO 2",
  116: "Phoenix NEO 2",
  "QH-SA059-B": "Ava NEO",
  "MLC-186-B": "Ava NEO",
};

export const getDeviceDisplayName = (deviceName) => {
  return DEVICE_NAME_MAPPING[deviceName] || deviceName;
};

export function createDevice(webBleDevice, stateCallback, isSendingData) {
  const deviceName = webBleDevice.name;
  let result = null;
  deviceWrappers.forEach((Wrapper) => {
    if (Wrapper.deviceNames.includes(deviceName)) {
      result = new Wrapper(webBleDevice, isSendingData);
      result.connectionStateCallback = stateCallback;
    }
  });

  if (result) {
    return result;
  } else {
    result = new RenamedDeviceWrapper(webBleDevice, isSendingData);
    result.connectionStateCallback = stateCallback;
    return result;
  }
}

/**
 * Connect a bluetooth device wrapper.
 * Device wrapper is a class around BluetoothDevice.
 * https://developer.mozilla.org/en-US/docs/Web/API/BluetoothDevice
 * The wrapper cannot exist without BluetoothDevice and cannot be created without
 * actual connection to the bluetooth device.
 * @return a promise with is resolved with the device wrapper
 */
export const discoverDevice = async (stateCallback, isSendingData) => {
  const allDevices = getAllDeviceNames().map((name) => ({ name }));
  const allServices = deviceWrappers.reduce(
    (services, wrapper) => services.concat(wrapper.services),
    []
  );
  allServices.push("battery_service");

  console.log("allDevices", allDevices);
  console.log("allServices", allServices);
  const options = {
    filters: [
      ...allDevices,
      { manufacturerData: [{ companyIdentifier: 1445 }] }, // Kiiroo company identifier (in case of Kiiroo device is renamed)
    ],
    optionalServices: allServices,
  };

  console.log("Selecting device");
  let device = null;
  try {
    device = await navigator.bluetooth.requestDevice(options);
  } catch (error) {
    console.warn("Device selection was probably cancelled, reason:", error);

    if (isSendingData) {
      Sentry.captureException(error);
    }
    return null;
  }
  console.log(`Device selected. Name: ${device.name}, device id: ${device.id},
                  connected: ${device.gatt.connected}. Connecting to the device...`);
  const deviceWrapper = await createDevice(
    device,
    stateCallback,
    isSendingData
  );
  return deviceWrapper;
};
